import {getAddressOptions, injectAddressFieldsIntoSchema} from 'utils/addressSchemaUtils';

const getSchema = (schema, addresses = []) => {
  const addressOptions = getAddressOptions(addresses);

  const processedSchema = injectAddressFieldsIntoSchema(schema, addressOptions, {
    selectorField: 'perAddressSelector',
    defaultValue: 'new_address',
    targetFieldPrefix: 'per_add_',
  });

  return injectAddressFieldsIntoSchema(processedSchema, addressOptions, {
    selectorField: 'corrAddressSelector',
    defaultValue: 'new_address',
    targetFieldPrefix: 'corr_add_',
  });
};

export {getSchema};
